/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { setKeyboard, setLockControl } from "../store/slice/privateSlice";
import store from "../store/store";

export const handleSetLockControl = (callback) => {
    store.dispatch(setLockControl(callback));
}

export const handleSetKeyboard = (type, visible, callback) => {
    store.dispatch(setKeyboard({ type, visible, callback }));
}